import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import Dashboard from './Dashboard';
import { loginActions } from '../store/actions/dashboard/login';
import { newentryActions } from '../store/actions/dashboard/newentry';

const mapStateToProps = state => {
    const { login, newentry } = state;
    const { isLogin, loginUser } = login;
    const { newEntryData, visiterData, visiterEntries, showNewEntry } = newentry;
    return {
        isLogin,
        loginUser,
        showNewEntry,
        newEntryData,
        visiterData,
        visiterEntries
    };
}

const mapDispatchToProps = (dispatch) => ({
    loginActions: bindActionCreators(loginActions, dispatch),
    newentryActions: bindActionCreators(newentryActions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(Dashboard)